// extracted by mini-css-extract-plugin
module.exports = {"container":"WhaleVaultScreen_container__1QJV-"};